import React, { useState, useEffect, useCallback } from 'react'
import Axios from 'axios'
import Form from 'react-bootstrap/Form'
import GoogleMap from '../maps/googleMap'
import Cookies from 'universal-cookie'

// Cookies
const cookies = new Cookies()
const user_id = cookies.get('user_id')

const EstateAdd = (props) => {

    /* Endpoint url */
    const endpoint = props.base_url + "endpoint/estate"

    /* Initial form */
    const [categories, useCategories] = useState([])
    const [categoryId, setCategoryId] = useState(0)
    const [showFields, setShowFields] = useState(false)
    const [fields, setFields] = useState([])

    /* formData construction */
    const [services, setServices] = useState([])
    const [customFields, setCustomFields] = useState({})
    const [commonFields, setCommonFields] = useState({ user_id: user_id })
    const [servicesFields, setServicesFields] = useState({})
    const [googleMap, setGoogleMap] = useState([])
    const [formData, setFormData] = useState({})

    /* For image uploading use */
    const [mainImage, setMainImage] = useState(null)
    const [additionalImages, setAdditionalImages] = useState([])

    /* For bd use */
    const [image, setImage] = useState([])
    const [thumbNails, setThumbNails] = useState([])

    /* Starting categories selector and showing according fields*/
    const SetCategories = (data) => useCategories(data)
    const SetFields = (data) => { setFields(data); setShowFields(true) }

    /* Handlers */
    const handleSelect = (e) => {
        resetForm()
        FetchFields(e.target.value)
    }

    const handleCustomFields = (e) => {
        let name = e.target.getAttribute('id')
        let value = e.target.value
        let description = e.target.getAttribute('data-value')
        setCustomFields({ ...customFields, [name]: { name: [name], description: [description], value: [value] } })
    }

    const handleCommonFields = (e) => {
        let name = e.target.getAttribute('id')
        let value = e.target.value
        setCommonFields({ ...commonFields, [name]: value })
    }

    const handleServicesFields = (e) => {
        let name = e.target.getAttribute('id')
        let value = e.target.value
        let description = e.target.getAttribute('data-value')
        setServicesFields({ ...servicesFields, [name]: { name: [name], description: [description], value: [value] } })
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        imageUpload()
    }

    /* Form handlers */
    const UpdateForm = () => {
        setFormData({
            category_id: categoryId,
            commonFields,
            customFields,
            servicesFields,
            googleMap,
            image,
            thumbNails
        })
    }

    const resetForm = () => {
        setShowFields(false)
        setCustomFields({})
        setCommonFields({ user_id: user_id })
        setServicesFields({})
        setFormData({})
    }

    /* Calls */
    const FetchCategories = () => {
        Axios.post(endpoint, { operation: "read_categories", api_key: props.api_key })
            .then(res => {
                SetCategories(res.data)
            })
    }

    const FetchFields = (category) => {
        Axios.post(endpoint, { operation: "read_category_and_custom_fields", api_key: props.api_key, category_id: category })
            .then(res => {
                if (res.data.length > 0) {
                    SetFields(res.data[0].fields.custom_fields)
                    setServices(res.data[0].fields.services)
                    setCategoryId(category)
                }
            })
    }

    const createEstate = () => {
        Axios.post(endpoint, { operation: "create_estate", api_key: props.api_key, formData })
            .then(res => {
                console.log(res.data)
                props.closeModal()
            })
    }

    /* Callbacks */
    const SetGoogleMap = useCallback(
        (data) => {
            setGoogleMap(data)
        }, []
    )

    /* Effects */
    useEffect(() => {
        FetchCategories()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        UpdateForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [commonFields, customFields, servicesFields, googleMap, image, thumbNails])

    /* Add images */
    const addMainImage = event => {
        setMainImage({ mainImage: event.target.files[0] })
        setImage([event.target.files[0].name])
    }

    const addAdditionalImage = event => {
        const value = Object.values(event.target.files)
        let new_additional_images = [...additionalImages]
        let new_thumbnails = [...thumbNails]
        value.map((item) => {
            new_additional_images = [...new_additional_images, item]
            new_thumbnails = [...new_thumbnails, item.name]
            return new_thumbnails
        })
        setAdditionalImages(new_additional_images)
        setThumbNails(new_thumbnails)
        document.getElementById('selectedFile2').value = ""

    }

    const removeAdditionalImage = event => {
        let values = [...additionalImages]
        let new_values = values.filter((value) => { return value.name !== event.target.getAttribute('id') })
        let thumbNails_old = [...thumbNails]
        let thumbNails_new = thumbNails_old.filter((value) => { return value !== event.target.getAttribute('id') })
        setAdditionalImages(new_values)
        setThumbNails(thumbNails_new)
    }

    const imageUpload = () => {
        const fd = new FormData();
        fd.append('image', mainImage.mainImage, mainImage.mainImage.name);
        Axios.post(props.base_url +'/endpoint/upload.php', fd
        ).then(res => {
            console.log(res);
        }
        );

        imageUpload2()
    }

    const imageUpload2 = () => {
        additionalImages.map((item) => {
            const fd = new FormData();
            fd.append('image', item, item.name);
            Axios.post(props.base_url + '/endpoint/upload.php', fd
            ).then(res => {
                console.log(res);
            }
            );
            return true
        })
        createEstate(formData)
    }

    return (
        <>
            <Form>
                <Form.Group controlId="exampleForm.SelectCustom">
                    <Form.Control as="select" custom onChange={handleSelect}>
                        <option value="null"> --- </option>
                        {categories.map((item, index) => (
                            <option key={index} value={item.category_id}>{item.name}</option>
                        ))}
                    </Form.Control>
                </Form.Group>
            </Form>
            {showFields &&
                <>
                    <div>
                        <h5>Seleccionar imagen principal</h5>
                        {mainImage &&
                            <p>{mainImage.mainImage.name}</p>
                        }
                        <input type="file" id="selectedFile" style={{ display: 'none' }} onChange={addMainImage} />
                        <input className="mb-3 btn btn-sm btn-secondary" type="button" value="Elegir imagen" onClick={() => document.getElementById('selectedFile').click()} />

                        <h5>Seleccionar imagenes adicionales</h5>
                        {additionalImages && additionalImages.map((item, index) => (
                            <p key={index}>{item.name} <span id={item.name} style={{ cursor: 'pointer' }} onClick={removeAdditionalImage} className="text-danger">Borrar</span></p>
                        ))}
                        <input type="file" id="selectedFile2" style={{ display: 'none' }} onChange={addAdditionalImage} multiple />
                        <input className="mb-3 btn btn-sm btn-secondary" type="button" value="Elegir imagen" onClick={() => document.getElementById('selectedFile2').click()} />
                        <button className="btn btn-sm btn-danger" style={{ top: '-8px', marginLeft: '1rem', position: 'relative' }} onClick={() => {
                            setAdditionalImages([])
                            setThumbNails([])
                            document.getElementById('selectedFile2').value = ""
                        }}>Borrar Todas</button>
                    </div>
                    <Form action="#" onSubmit={handleSubmit}>
                        <Form.Group controlId="title">
                            <div className="row">
                                <div className="col-4"><Form.Label>Leyenda de presentación</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="transaction">
                            <div className="row">
                                <div className="col-4"><Form.Label>Transacción pretendida</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="asking_price">
                            <div className="row">
                                <div className="col-4"><Form.Label>Asking price</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="street">
                            <div className="row">
                                <div className="col-4"><Form.Label>Calle y número</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="street_2">
                            <div className="row">
                                <div className="col-4"><Form.Label>Colonia</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="zone">
                            <div className="row">
                                <div className="col-4"><Form.Label>Municipio/Alcaldía</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="state">
                            <div className="row">
                                <div className="col-4"><Form.Label>Estado</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        {fields.map((item, index) => (
                            <Form.Group key={index} controlId={item.field_name}>
                                <div className="row">
                                    <div className="col-4"><Form.Label>{item.field_description}</Form.Label></div>
                                    <div className="col-8"><Form.Control type="text" data-value={item.field_description} onKeyUp={handleCustomFields} /></div>
                                </div>
                            </Form.Group>
                        ))}
                        <h3 className="mb-3">Servicios</h3>
                        <Form.Group controlId="energy">
                            <div className="row">
                                <div className="col-4"><Form.Label>Energia</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="water">
                            <div className="row">
                                <div className="col-4"><Form.Label>Agua</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="communications">
                            <div className="row">
                                <div className="col-4"><Form.Label>Telecomunicaciones</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="natural_gas">
                            <div className="row">
                                <div className="col-4"><Form.Label>Gas natural</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>

                        {services && services.map((item, index) => (
                            <Form.Group key={index} controlId={item.field_name}>
                                <div className="row">
                                    <div className="col-4"><Form.Label>{item.field_description}</Form.Label></div>
                                    <div className="col-8"><Form.Control type="text" data-value={item.field_description} onKeyUp={handleServicesFields} /></div>
                                </div>
                            </Form.Group>
                        ))}
                        <h3 className="mb-3">Vecindario</h3>
                        <Form.Group controlId="neighbours">
                            <div className="row">
                                <div className="col-4"><Form.Label>Vecinos adyacentes y cercanos</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="surroundings">
                            <div className="row">
                                <div className="col-4"><Form.Label>Descripción del entorno</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <Form.Group controlId="indications">
                            <div className="row">
                                <div className="col-4"><Form.Label>Como llegar?</Form.Label></div>
                                <div className="col-8"><Form.Control type="text" onKeyUp={handleCommonFields} /></div>
                            </div>
                        </Form.Group>
                        <GoogleMap SetGoogleMap={SetGoogleMap} />
                        <button className="btn btn-primary">Guardar</button>
                    </Form>
                </>
            }
        </>
    )
}
export default EstateAdd